/**
 * OA Product Slider — Swipeable carousel met autoplay
 * Door Online Actief (online-actief.nl)
 */
(() => {
  function initProductSliders() {
    document.querySelectorAll('.oa-ps').forEach(slider => {
      if (slider._oaPS) return;
      slider._oaPS = true;

      const carousel = slider.querySelector('[data-oa-ps-carousel]');
      if (!carousel) return;

      /* Zorg dat slider start bij eerste product (volledig zichtbaar) */
      requestAnimationFrame(() => { carousel.scrollLeft = 0; });

      const prevBtn = slider.querySelector('[data-oa-ps-prev]');
      const nextBtn = slider.querySelector('[data-oa-ps-next]');
      const autoplay = slider.dataset.autoplay === 'true';
      const speed = parseInt(slider.dataset.autoplaySpeed, 10) || 4000;
      let timer = null;

      function getScrollAmount() {
        const card = carousel.querySelector('.oa-ps__card');
        if (!card) return 300;
        const gap = parseFloat(getComputedStyle(carousel).gap) || 20;
        const perPage = window.innerWidth <= 999 ? 2 : 4;
        return (card.offsetWidth + gap) * perPage;
      }

      function scrollNext() {
        const amount = getScrollAmount();
        const maxScroll = carousel.scrollWidth - carousel.clientWidth;
        if (carousel.scrollLeft >= maxScroll - 10) {
          carousel.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          carousel.scrollBy({ left: amount, behavior: 'smooth' });
        }
      }

      function scrollPrev() {
        const amount = getScrollAmount();
        if (carousel.scrollLeft <= 10) {
          carousel.scrollTo({ left: carousel.scrollWidth, behavior: 'smooth' });
        } else {
          carousel.scrollBy({ left: -amount, behavior: 'smooth' });
        }
      }

      function startAutoplay() { stopAutoplay(); if (autoplay) timer = setInterval(scrollNext, speed); }
      function stopAutoplay() { clearInterval(timer); }

      if (prevBtn) prevBtn.addEventListener('click', () => { scrollPrev(); startAutoplay(); });
      if (nextBtn) nextBtn.addEventListener('click', () => { scrollNext(); startAutoplay(); });

      slider.addEventListener('mouseenter', stopAutoplay);
      slider.addEventListener('mouseleave', startAutoplay);
      carousel.addEventListener('touchstart', stopAutoplay, { passive: true });
      carousel.addEventListener('touchend', () => { setTimeout(startAutoplay, 3000); }, { passive: true });
      document.addEventListener('visibilitychange', () => { document.hidden ? stopAutoplay() : startAutoplay(); });

      /* Veeg-peek (alleen touch): toon de 2e foto onder de vinger tijdens vegen.
         Een pure tik beweegt niet en zet dus geen --peek -> het product opent gewoon. */
      if ('ontouchstart' in window) {
        let peeked = null;
        const clearPeek = () => { if (peeked) { peeked.classList.remove('oa-ps__card--peek'); peeked = null; } };
        carousel.addEventListener('touchmove', (e) => {
          const t = e.touches && e.touches[0];
          if (!t) return;
          const el = document.elementFromPoint(t.clientX, t.clientY);
          const card = (el && el.closest) ? el.closest('.oa-ps__card') : null;
          if (card === peeked) return;
          clearPeek();
          if (card && slider.contains(card)) { card.classList.add('oa-ps__card--peek'); peeked = card; }
        }, { passive: true });
        carousel.addEventListener('touchend', clearPeek, { passive: true });
        carousel.addEventListener('touchcancel', clearPeek, { passive: true });
      }

      startAutoplay();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductSliders);
  } else {
    initProductSliders();
  }
  document.addEventListener('shopify:section:load', initProductSliders);
})();
